import React from 'react';
import { disposeOnUnmount, watch, Observe } from 'rewire-core';
import { WithStyle } from 'rewire-ui';
import Typography from '@material-ui/core/Typography';
import { Theme } from '@material-ui/core/styles';
import Loader from '../ui/Loader';
import InfoPanel, { IInfoPanelProps } from '../ui/InfoPanel';
import InfoPanelHeader from '../ui/InfoPanelHeader';
import InfoPanelEmployeeView from './InfoPanelEmployeeView';
import InfoPanelJobView from './InfoPanelJobView';
import InfoPanelShiftView from './InfoPanelShiftView';
import scheduleInfoPanelModel from './ScheduleInfoPanelModel';
import scheduleModel from './ScheduleModel';
import { withStyles } from '../utility/styles';

const styles = (_theme: Theme) => ({
  defaultMessage: {
    fontStyle: 'italic',
  },
});

interface IPanelProps {
  InfoPanelProps?: IInfoPanelProps;
}

interface IScheduleInfoPanelProps {
  classes?: any;
  EmployeePanelProps?: IPanelProps;
  ShiftPanelJobModeProps?: IPanelProps;
  ShiftPanelEmployeeModeProps?: IPanelProps;
  DefaultPanelProps?: IPanelProps;
}

type ScheduleInfoPanelProps = WithStyle<ReturnType<typeof styles>, IScheduleInfoPanelProps>;

class ScheduleInfoPanel extends React.PureComponent<ScheduleInfoPanelProps> {
  static defaultProps = {
    EmployeePanelProps: {
      InfoPanelProps: {
        defaultSize: {
          width: 450,
          height: '100%',
        },
        minWidth: 450,
      },
    },
    ShiftPanelJobModeProps: {
      InfoPanelProps: {
        defaultSize: {
          width: 532,
          height: '100%',
        },
        minWidth: 532,
      },
    },
    ShiftPanelEmployeeModeProps: {
      InfoPanelProps: {
        defaultSize: {
          width: 772,
          height: '100%',
        },
        minWidth: 772,
      },
    },
    DefaultPanelProps: {
      InfoPanelProps: {
        defaultSize: {
          width: 350,
          height: '100%',
        },
        minWidth: 350,
      },
    },
  };

  constructor(props: ScheduleInfoPanelProps) {
    super(props);

    scheduleInfoPanelModel.load();
  }

  UNSAFE_componentWillUpdate(_nextProps: IScheduleInfoPanelProps) {
    scheduleInfoPanelModel.load();
  }

  componentDidMount() {
    disposeOnUnmount(this, () => {
      watch(
        () => scheduleInfoPanelModel.selectedCell,
        () => {
          this.forceUpdate();
        },
      );
    });
  }

  getEditViewModel() {
    return scheduleInfoPanelModel?.currentInfoPanelModel?.currentViewModel?.editShiftModel;
  }

  render() {
    const { classes } = this.props;

    return (
      <Observe
        render={() => {
          const employeeCellSelected = scheduleInfoPanelModel.selectedCellType === 'Employee';
          const shiftCellSelected = scheduleInfoPanelModel.selectedCellType === 'Shift';
          const showUdfs = this.getEditViewModel()?.showUdfs;
          const ShiftPanelProps =
            scheduleModel.viewMode === 'Job' ? this.props.ShiftPanelJobModeProps : this.props.ShiftPanelEmployeeModeProps;
          if (ShiftPanelProps?.InfoPanelProps) {
            ShiftPanelProps.InfoPanelProps.minWidth =
              showUdfs === true ? 772 : showUdfs === false ? 532 : ShiftPanelProps.InfoPanelProps.minWidth;
          }
          const PanelProps = employeeCellSelected
            ? this.props.EmployeePanelProps
            : shiftCellSelected
              ? ShiftPanelProps
              : this.props.DefaultPanelProps;
          return (
            <InfoPanel {...PanelProps?.InfoPanelProps}>
              <Observe
                render={() => (
                  <Loader loading={scheduleModel.isLoading}>
                    <Observe
                      render={() => {
                        switch (scheduleInfoPanelModel.selectedCellType) {
                          case 'Employee':
                            return <InfoPanelEmployeeView />;

                          case 'Job':
                            return <InfoPanelJobView />;

                          case 'Shift':
                            return <InfoPanelShiftView />;

                          default:
                            return (
                              <InfoPanelHeader
                                title={
                                  <Typography className={classes.defaultMessage}>
                                    Selecting a cell displays the cell&apos;s properties in this area
                                  </Typography>
                                }
                              />
                            );
                        }
                      }}
                    />
                  </Loader>
                )}
              />
            </InfoPanel>
          );
        }}
      />
    );
  }
}

export default withStyles<IScheduleInfoPanelProps>(styles, ScheduleInfoPanel);
